export default __webpack_public_path__ + "static/media/goods-essentials.3e7947b6.svg";